export function generateSearchId() {
  return Number.parseInt(Math.random() * 1000000);
}